import React, { ForwardedRef, forwardRef } from "react";
import { TermsCardStyle } from "./TermsCardStyles";
import { motion } from "framer-motion";
import { TermsCardInterface } from "../../../interfaces/TermsCardInterface";

export const TermsCard = forwardRef(
  ({ img, title }: TermsCardInterface, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <TermsCardStyle ref={ref}>
        <div className="flex__center">
          <img src={img} alt="#" />
        </div>
        <p>{title}</p>
      </TermsCardStyle>
    );
  }
);

export const MTermsCard = motion.create(TermsCard);
